/* eslint-disable */
import _m0 from "protobufjs/minimal";

export const protobufPackage = "skills";

/**
 * This file automatically generated by skymarshal.
 * DO NOT MODIFY BY HAND!!!!
 */

export interface UiVariableKeys {
}

export enum UiVariableKeys_Enum {
  INVALID = 0,
  GIMBAL_PITCH = 1,
  HEADING = 2,
  HEADING_RATE = 3,
  SMOOTH_LOOKAT = 4,
  VEL_X = 5,
  VEL_Y = 6,
  VEL_Z = 7,
  POS_X = 8,
  POS_Y = 9,
  POS_Z = 10,
  POS_VEL_FRAME = 11,
  MAX_SPEED = 12,
  AZIMUTH = 13,
  AZIMUTH_DEADZONE = 14,
  AZIMUTH_RATE = 15,
  ELEVATION = 16,
  ELEVATION_DEADZONE = 17,
  HEIGHT = 18,
  HEIGHT_DEADZONE = 19,
  RANGE = 20,
  RANGE_DEADZONE = 21,
  ZOOM = 22,
  Z_PLANE_HEIGHT = 23,
  RAY_START_X = 24,
  RAY_START_Y = 25,
  RAY_START_Z = 26,
  RAY_END_X = 27,
  RAY_END_Y = 28,
  RAY_END_Z = 29,
  PINCH_ZOOM = 30,
  GIMBAL_PITCH_RATE = 31,
  UNRECOGNIZED = -1,
}

export function uiVariableKeys_EnumFromJSON(object: any): UiVariableKeys_Enum {
  switch (object) {
    case 0:
    case "INVALID":
      return UiVariableKeys_Enum.INVALID;
    case 1:
    case "GIMBAL_PITCH":
      return UiVariableKeys_Enum.GIMBAL_PITCH;
    case 2:
    case "HEADING":
      return UiVariableKeys_Enum.HEADING;
    case 3:
    case "HEADING_RATE":
      return UiVariableKeys_Enum.HEADING_RATE;
    case 4:
    case "SMOOTH_LOOKAT":
      return UiVariableKeys_Enum.SMOOTH_LOOKAT;
    case 5:
    case "VEL_X":
      return UiVariableKeys_Enum.VEL_X;
    case 6:
    case "VEL_Y":
      return UiVariableKeys_Enum.VEL_Y;
    case 7:
    case "VEL_Z":
      return UiVariableKeys_Enum.VEL_Z;
    case 8:
    case "POS_X":
      return UiVariableKeys_Enum.POS_X;
    case 9:
    case "POS_Y":
      return UiVariableKeys_Enum.POS_Y;
    case 10:
    case "POS_Z":
      return UiVariableKeys_Enum.POS_Z;
    case 11:
    case "POS_VEL_FRAME":
      return UiVariableKeys_Enum.POS_VEL_FRAME;
    case 12:
    case "MAX_SPEED":
      return UiVariableKeys_Enum.MAX_SPEED;
    case 13:
    case "AZIMUTH":
      return UiVariableKeys_Enum.AZIMUTH;
    case 14:
    case "AZIMUTH_DEADZONE":
      return UiVariableKeys_Enum.AZIMUTH_DEADZONE;
    case 15:
    case "AZIMUTH_RATE":
      return UiVariableKeys_Enum.AZIMUTH_RATE;
    case 16:
    case "ELEVATION":
      return UiVariableKeys_Enum.ELEVATION;
    case 17:
    case "ELEVATION_DEADZONE":
      return UiVariableKeys_Enum.ELEVATION_DEADZONE;
    case 18:
    case "HEIGHT":
      return UiVariableKeys_Enum.HEIGHT;
    case 19:
    case "HEIGHT_DEADZONE":
      return UiVariableKeys_Enum.HEIGHT_DEADZONE;
    case 20:
    case "RANGE":
      return UiVariableKeys_Enum.RANGE;
    case 21:
    case "RANGE_DEADZONE":
      return UiVariableKeys_Enum.RANGE_DEADZONE;
    case 22:
    case "ZOOM":
      return UiVariableKeys_Enum.ZOOM;
    case 23:
    case "Z_PLANE_HEIGHT":
      return UiVariableKeys_Enum.Z_PLANE_HEIGHT;
    case 24:
    case "RAY_START_X":
      return UiVariableKeys_Enum.RAY_START_X;
    case 25:
    case "RAY_START_Y":
      return UiVariableKeys_Enum.RAY_START_Y;
    case 26:
    case "RAY_START_Z":
      return UiVariableKeys_Enum.RAY_START_Z;
    case 27:
    case "RAY_END_X":
      return UiVariableKeys_Enum.RAY_END_X;
    case 28:
    case "RAY_END_Y":
      return UiVariableKeys_Enum.RAY_END_Y;
    case 29:
    case "RAY_END_Z":
      return UiVariableKeys_Enum.RAY_END_Z;
    case 30:
    case "PINCH_ZOOM":
      return UiVariableKeys_Enum.PINCH_ZOOM;
    case 31:
    case "GIMBAL_PITCH_RATE":
      return UiVariableKeys_Enum.GIMBAL_PITCH_RATE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return UiVariableKeys_Enum.UNRECOGNIZED;
  }
}

export function uiVariableKeys_EnumToJSON(object: UiVariableKeys_Enum): string {
  switch (object) {
    case UiVariableKeys_Enum.INVALID:
      return "INVALID";
    case UiVariableKeys_Enum.GIMBAL_PITCH:
      return "GIMBAL_PITCH";
    case UiVariableKeys_Enum.HEADING:
      return "HEADING";
    case UiVariableKeys_Enum.HEADING_RATE:
      return "HEADING_RATE";
    case UiVariableKeys_Enum.SMOOTH_LOOKAT:
      return "SMOOTH_LOOKAT";
    case UiVariableKeys_Enum.VEL_X:
      return "VEL_X";
    case UiVariableKeys_Enum.VEL_Y:
      return "VEL_Y";
    case UiVariableKeys_Enum.VEL_Z:
      return "VEL_Z";
    case UiVariableKeys_Enum.POS_X:
      return "POS_X";
    case UiVariableKeys_Enum.POS_Y:
      return "POS_Y";
    case UiVariableKeys_Enum.POS_Z:
      return "POS_Z";
    case UiVariableKeys_Enum.POS_VEL_FRAME:
      return "POS_VEL_FRAME";
    case UiVariableKeys_Enum.MAX_SPEED:
      return "MAX_SPEED";
    case UiVariableKeys_Enum.AZIMUTH:
      return "AZIMUTH";
    case UiVariableKeys_Enum.AZIMUTH_DEADZONE:
      return "AZIMUTH_DEADZONE";
    case UiVariableKeys_Enum.AZIMUTH_RATE:
      return "AZIMUTH_RATE";
    case UiVariableKeys_Enum.ELEVATION:
      return "ELEVATION";
    case UiVariableKeys_Enum.ELEVATION_DEADZONE:
      return "ELEVATION_DEADZONE";
    case UiVariableKeys_Enum.HEIGHT:
      return "HEIGHT";
    case UiVariableKeys_Enum.HEIGHT_DEADZONE:
      return "HEIGHT_DEADZONE";
    case UiVariableKeys_Enum.RANGE:
      return "RANGE";
    case UiVariableKeys_Enum.RANGE_DEADZONE:
      return "RANGE_DEADZONE";
    case UiVariableKeys_Enum.ZOOM:
      return "ZOOM";
    case UiVariableKeys_Enum.Z_PLANE_HEIGHT:
      return "Z_PLANE_HEIGHT";
    case UiVariableKeys_Enum.RAY_START_X:
      return "RAY_START_X";
    case UiVariableKeys_Enum.RAY_START_Y:
      return "RAY_START_Y";
    case UiVariableKeys_Enum.RAY_START_Z:
      return "RAY_START_Z";
    case UiVariableKeys_Enum.RAY_END_X:
      return "RAY_END_X";
    case UiVariableKeys_Enum.RAY_END_Y:
      return "RAY_END_Y";
    case UiVariableKeys_Enum.RAY_END_Z:
      return "RAY_END_Z";
    case UiVariableKeys_Enum.PINCH_ZOOM:
      return "PINCH_ZOOM";
    case UiVariableKeys_Enum.GIMBAL_PITCH_RATE:
      return "GIMBAL_PITCH_RATE";
    case UiVariableKeys_Enum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

function createBaseUiVariableKeys(): UiVariableKeys {
  return {};
}

export const UiVariableKeys = {
  encode(_: UiVariableKeys, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): UiVariableKeys {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUiVariableKeys();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): UiVariableKeys {
    return {};
  },

  toJSON(_: UiVariableKeys): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<UiVariableKeys>, I>>(base?: I): UiVariableKeys {
    return UiVariableKeys.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UiVariableKeys>, I>>(_: I): UiVariableKeys {
    const message = createBaseUiVariableKeys();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };
